const readReportCount = (span) => parseFloat($(span).attr("data-count"));

export default readReportCount;
